<script setup lang="ts">
const { t } = useI18n()
const signatureStore = useSignatureStore()

signatureStore.setIsSignaturePage(false)
</script>

<template>
  <main>
    <ClientOnly fallback-tag="div">
      <ConfiguratorBase />
      <template #fallback>
        <div class="grid mt-28rem w-full place-items-center">
          <AppLoadingIndicator class="size-8rem transition" />
          <h1 class="mt-2rem text-2rem">
            {{ t('configurator.loading') }}
          </h1>
        </div>
      </template>
    </ClientOnly>
  </main>
</template>
